module.exports = __webpack_public_path__ + "img/logo.4077c367.png";